module.exports = __webpack_public_path__ + "img/EZPark_Logo.5d0f7892.png";